import conversions from '../conversions.js'
import settings from '../settings.js'

export default {


    computed : {
    
        unit_distance : function(){
            return settings.getDistanceUnit();
        },
        bootstrap_div_classes : function(){
            return "dbtn-group dbtn-group-toggle"
        },
        total_annual_cost : function(){
            let tc = this.total_annual_energy_cost
            for(let c in this.commutes){
                tc += this.vehicle_total_per_year(this.commutes[c].data)
            }
            this.$emit('total_annual_cost', tc)
            return tc
        },

        total_annual_fuel_cost : function(){
            let ec = 0
            for(let c in this.commutes){
                ec += this.vehicle_fuel_cost_per_year(this.commutes[c].data)
            }
            return ec
        },
        total_annual_fuel_volume : function(){
            let v = 0
            for(let c in this.commutes){
                v += this.fuel_volume_per_year(this.commutes[c].data)
            }
            return v
        },
        total_annual_electricity : function(){
            let e = 0
            for(let c in this.commutes){
                e += this.electricity_per_year(this.commutes[c].data)
            }
            
            return e
        },
        
        total_annual_electricity_cost : function(){
            let ec = 0
            for(let c in this.commutes){
                ec += this.vehicle_electricity_cost_per_year(this.commutes[c].data)
            }
            
            return ec
        },
             
        total_annual_energy_cost : function(){
            let ec = 0
            for(let c in this.commutes){
                ec += this.vehicle_annual_energy_cost(this.commutes[c].data)
            }
            this.$emit('total_annual_energy_cost', ec)
            return ec
        }
    },
    methods: {
        vehicle_label : function(vehicle){
            let k = 'vehicles.'+vehicle['vehicle']
            if(vehicle['vehicle'] == 'other'){
                k = 'other_vehicles.'+vehicle['other_vehicle']
            }

            return this.$t(k)
        },

        vehicle_environment_badge: function(commute){
            if(this.vehicle_ic(commute)){
                return 'sad'
            }
            if(['car', 'motorcycle'].includes(commute.vehicle['vehicle']) && this.vehicle_electric(commute)){
                return 'sad'

            }
            if(this.vehicle_electric(commute)){
                return 'happy'
            }
            return 'happy'
            
        },
        
        vehicle_ic : function(commute){
            if(['car', 'motorcycle'].includes(commute.vehicle['vehicle'])){
                if(['gas', 'diesel', 'hybrid', 'lpg'].includes(commute.vehicle_costs['energy_source'])){
                    return true
                }
            }
            return false
        },
        
        vehicle_electric : function(commute){
            if(['car', 'motorcycle'].includes(commute.vehicle['vehicle'])){
                if(['electric'].includes(commute.vehicle_costs['energy_source'])){
                    return true
                }
            }
            if(['e-bicycle'].includes(commute.vehicle['vehicle'])){
                return true
            }                
            return false
        },
        fuel_volume_per_year : function(commute){
            if(this.vehicle_ic(commute)){
                let lp100km = commute.vehicle_costs['fuel_consumption'];
                return parseFloat((this.km_per_year(commute) / 100) * lp100km)
            }
            return 0
        },
        electricity_per_year : function(commute){
            if(this.vehicle_electric(commute)){
                return (this.km_per_year(commute) / parseFloat(commute.vehicle_costs['electric_charge_distance']))
                * parseFloat(commute.vehicle_costs['electric_charge_capacity'])
            }
            return 0
        },
        vehicle_total_per_year : function(commute){
            if(commute.complete){
                return this.vehicle_maintenance_cost_per_year(commute) + this.vehicle_cost_per_year(commute)
            }
            //console.log("vehicle_cost_per_year 0")
        
            return 0
        },
        vehicle_cost_per_year : function(commute){
            if(commute.complete){
                if(['car', 'motorcycle'].includes(commute.vehicle['vehicle'])){
                    return (
                        parseFloat(commute.vehicle_costs['monthly_parking'])
                      + parseFloat(commute.vehicle_costs['monthly_loan'])
                      + parseFloat(commute.vehicle_costs['monthly_insurance'])) * 12
                      
                }
                if(['public', 'other', 'bicycle', 'e-bicycle'].includes(commute.vehicle['vehicle'])){
                    //console.log("vehicle_cost_per_year ['public', 'other', 'bicycle', 'e-bicycle'].includes(commute.vehicle['vehicle']")
                    return parseFloat(commute.vehicle_costs['monthly_cost'] || 0) * 12
                }
            }
            //console.log("vehicle_cost_per_year 0")
        
            return 0
        },

        vehicle_maintenance_cost_per_year: function(commute){
            //console.log("commute.vehicle.maintenance_costs = "+JSON.stringify(commute.vehicle.maintenance_costs))

            let total = 0
            let kpy = this.km_per_year(commute)
            if(!['public'].includes(commute.vehicle['vehicle'])){
                for(let k in commute.vehicle_costs.maintenance_costs){
                    let count = kpy / commute.vehicle_costs.maintenance_costs[k].freq
                    let cost = commute.vehicle_costs.maintenance_costs[k].cost
                    /*console.log("k = "+k)
                    console.log("freq = "+commute.vehicle.maintenance_costs[k].freq)
                    console.log("kpy = "+kpy)
                    console.log("count = "+count)
                    console.log("cost = "+cost)
                    console.log(" ")*/
                    total = total + (cost * count)
                    
                }
            }
            //console.log("total = "+total)

            return total
        },
        vehicle_annual_energy_cost : function(commute){
            return this.vehicle_electricity_cost_per_year(commute) + this.vehicle_fuel_cost_per_year(commute)
        },
        
        vehicle_cost_per_dist_unit : function(commute){
            let epy = this.vehicle_electricity_cost_per_year(commute)
            let fpy = this.vehicle_fuel_cost_per_year(commute)
            let vpy = this.vehicle_total_per_year(commute)
            
            //console.log(epy + fpy + vpy)
            
            return (epy + fpy + vpy) / this.convert('convertDistance', this.km_per_year(commute))
        },
        
        vehicle_fuel_cost_per_year : function(commute){
            // ic here
            if(this.vehicle_ic(commute)){
                return this.fuel_volume_per_year(commute) * this.energy_costs[commute.vehicle_costs['energy_source']]
            }
            return 0
        },
        vehicle_electricity_cost_per_year : function(commute){
            // electric here
            if(this.vehicle_electric(commute)){
                return this.electricity_per_year(commute) * this.energy_costs['electricity']
            }
            return 0              

        },
        
        commute_annual_cost : function(commute){
            return this.vehicle_total_per_year(commute)
            + this.vehicle_fuel_cost_per_year(commute)
            + this.vehicle_electricity_cost_per_year(commute)
        },
        
        commutes_per_year : function(commute){
            return commute.commutes_per_day *  365.25
        },
        
        dist_per_commute : function(commute){
            return commute.commute_dist_time['commute_dist']
        },
        
        avg_commute_speed : function(commute){
            // returns speed in {unit_distance} per hour
            return commute.commute_dist_time['commute_dist'] / parseFloat(commute.commute_dist_time['commute_duration']) * 60
        },
        km_per_year : function(commute){
            return parseFloat(commute.commutes_per_day * commute.commute_dist_time['commute_dist'] * 365.25);
        },
        duration_per_year : function(commute){
            // returns duration in hours
            return this.km_per_year(commute) / this.avg_commute_speed(commute)
        },
        
        display_function: function(t){
            let unit;
            switch(t) {
                case 'distance':
                    unit = settings.getDistanceUnit();
                    if(unit == 'km'){
                        return function(d){return d}
                    }
                    return conversions['km2'+unit];
                break;

                case 'volume':
                    unit = settings.getVolumeUnit();
                    if(unit == 'l'){
                        return function(d){return d}
                    }
                    return conversions['l2'+unit];
            }
        },
        store_function: function(t){
            let unit;
            switch(t) {
                case 'distance':
                    unit = settings.getDistanceUnit();
                    if(unit == 'km'){
                        return function(d){return d}
                    }
                    return conversions[unit+'2km']
                break;
                case 'volume':
                    unit = settings.getVolumeUnit();
                    if(unit == 'l'){
                        return function(d){return d}
                    }
                    return conversions[unit+'2l']
            }
        },
        settings : function(fn, ...args){
            return settings[fn](...args);
        },
        convert: function(fn, ...args){
            return conversions[fn](...args);
        },
    }
}